import { fetchPersea } from "@/config/axios/config-axios";

interface UploadFileResponse {
    url: string;
    ipfs_gateway: string;
}

export const uploadFile = async (file: File): Promise<UploadFileResponse> => {
    const formData = new FormData();
    formData.append("files", file, file.name);
    
    try {
        const response = await fetchPersea(
            '/files',
            'POST',
            {
                domain: import.meta.env.VITE_DOMAIN
            },
            formData,
            import.meta.env.VITE_X_API_KEY
        );
        
        if (!response?.urls?.[0]) {
            throw new Error('No URL returned from server');
        }

        return {
            url: response.urls[0],
            ipfs_gateway: response.ipfs_gateway
        };
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(`Failed to upload file: ${error.message}`);
        }
        throw new Error('Failed to upload file');
    }
};